import styled from 'styled-components'

export const ViewElement = styled.div`
  padding-right: 1.2rem;
  padding-left: 1.2rem;
`

export const CartListing = styled(ViewElement)`
  padding-top: 0.5rem;
  margin-bottom: 1.2rem;
`
